import { firebaseRequest } from '@/utils/request'

export const reqGetRecord = (params) =>
  firebaseRequest.get('recordBehavior', { params })

export const reqAddRecord = (payload) =>
  firebaseRequest.post('recordBehavior', payload)



// WEBPACK FOOTER //
// ./src/api/recordBill/index.js